import { ProgramNames } from '../../../models/programs/Programs'
import { ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

/**
 * Behavioral Health Urgent Care is a "shell" program: it wires the `behavioralHealthUrgentCare`
 * customer property to its triage treatment options so HPI eligibility checks are scoped to this program.
 *
 * It has no direct booking flow (members are routed to the pediatrics contact page) and no Lyra Care sessions.
 */
export const BEHAVIORAL_HEALTH_URGENT_CARE_PROGRAM = {
  programName: ProgramNames.BehavioralHealthUrgentCare,
  blendedCareProgramId: null,
  customerPropertyId: ProgramCustomerPropertyId.behavioralHealthUrgentCare,

  displayLabels: {
    default: ProgramDisplayLabels.behavioralHealthUrgentCare,
    sessionSummary: 'behavioral health urgent care',
  },

  associatedProviderTypes: [],
  associatedProviderModalities: [],

  canRescheduleAppointment: false,
  selfPayEligible: false,

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [
      TREATMENT_OPTIONS.PEDIATRIC_BEHAVIORAL_HEALTH_URGENT_CARE,
      TREATMENT_OPTIONS.PEDIATRIC_BEHAVIORAL_HEALTH_URGENT_CARE_CHILD,
    ],
    isFullTreatmentOption: true,
  },

  consents: [],
} satisfies ProgramConfig

/**
 * Pediatric Virtual Intensive Outpatient Program is a "shell" program: it wires the
 * `pediatricVirtualIntensiveOutpatientProgram` customer property to its triage treatment options
 * so HPI eligibility checks are scoped to this program.
 *
 * It has no direct booking flow (members are routed to the pediatrics contact page) and no Lyra Care sessions.
 */
export const PEDIATRIC_VIRTUAL_INTENSIVE_OUTPATIENT_PROGRAM = {
  programName: ProgramNames.PediatricVirtualIntensiveOutpatientProgram,
  blendedCareProgramId: null,
  customerPropertyId: ProgramCustomerPropertyId.pediatricVirtualIntensiveOutpatientProgram,

  displayLabels: {
    default: ProgramDisplayLabels.pediatricVirtualIntensiveOutpatientProgram,
    sessionSummary: 'virtual intensive outpatient program',
  },

  associatedProviderTypes: [],
  associatedProviderModalities: [],

  canRescheduleAppointment: false,
  selfPayEligible: false,

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [
      TREATMENT_OPTIONS.PEDIATRIC_VIRTUAL_INTENSIVE_OUTPATIENT_PROGRAM,
      TREATMENT_OPTIONS.PEDIATRIC_VIRTUAL_INTENSIVE_OUTPATIENT_PROGRAM_CHILD,
    ],
    isFullTreatmentOption: true,
  },

  consents: [],
} satisfies ProgramConfig
